import styled from 'styled-components';

export const Carousel = styled.div`
  display: flex;
  height: fit-content;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  transition: transform 1s ease;
`;

export const  CloseModal = styled.div`
  position: absolute;
  top: 24px;
  right: 50px;
  z-index: 2000;
  cursor: pointer;
`;

export const PrevButton = styled.button`
  position: absolute;
  top: 50%;
  background-color: transparent;
  border: none;
  cursor: pointer;
  left: 33%;
  // z-index: 1;
`;

export const NextButton = styled.button`
  position: absolute;
  top: 50%;
  background-color: transparent;
  border: none;
  cursor: pointer;
  right: 33%;
  // z-index: 1;
`;